<template>
	<b-modal :ref="modalRefName" :visible="status" :hide-footer="true">
		<template #modal-title>
			<span style="color: #1a3e53">
				<b-icon icon="file-check" />
				{{ title }}
			</span>
		</template>

		<div v-if="loading" style="text-align: center">
			<b-icon icon="stopwatch" font-scale="3" animation="cylon" class="mt-3 mb-3" />
			<p id="cancel-label">
				Votre facture est en cours de création... Patientez quelques instants, ne fermez pas cette fenêtre,
				votre facture va être automatiquement téléchargée.
			</p>
		</div>

		<div v-else-if="registered" style="text-align: center">
			<p>
				Votre facture a été téléchargée, vous la trouverez en bas à droite de votre navigateur ou dans le
				dossier "Téléchargements" de votre ordinateur.
			</p>
			<p>
				Nous vous offrons également 15 jours d'essai gratuits de l'outil de facturation et comptabilité Sinao.
				Vous pourrez faire vos factures gratuitement sur cet outil, il gèrera automatiquement pour vous toutes
				les mentions légales, les numéros des factures, les dates et bien plus encore. À la fin des 15 jours,
				vous pourrez continuer gratuitement à utiliser Sinao à vie jusqu'à 5 factures par mois grâce à notre
				offre "FREEMIUM".
			</p>

			<b-button class="w-100 mt-2" variant="success" size="lg" @click="goToApp">
				Découvrir Sinao
			</b-button>
		</div>

		<form v-else ref="form" @submit.stop.prevent="handleSubmit">
			<b-form-group class="label" label="Email" label-cols="12">
				<b-form-input v-model="email" class="w-full" placeholder="Email" type="email" />
			</b-form-group>
			<b-form-group class="label" label="Mot de passe" label-cols="12">
				<b-form-input v-model="password" type="password" class="w-full" placeholder="Mot de passe" />
			</b-form-group>
			<b-form-group class="label" label="Prénom" label-cols="12">
				<b-form-input v-model="firstname" class="w-full" placeholder="Prénom" type="text" />
			</b-form-group>
			<b-form-group class="label" label="Nom" label-cols="12">
				<b-form-input v-model="lastname" class="w-full" placeholder="Nom" type="text" />
			</b-form-group>
			<b-form-group class="label" label="Nom de votre entreprise" label-cols="12">
				<b-form-input v-model="appName" class="w-full" placeholder="Nom de votre entreprise" type="text" />
			</b-form-group>
			<span>
				<input id="cgu" v-model="cgu" type="checkbox" name="cgu" class="mx-2 checkbox" />
				<label for="cgu">
					J'ai lu et j'accepte les
					<a
						href="#"
						class="text-lien"
						@click="openPage('cgu', false)"
						@keydown.enter="openPage('cgu', false)"
					>
						Conditions Générales d'Utilisation
					</a>
				</label>
			</span>

			<b-button class="w-100 mt-2" variant="primary" size="lg" @click="handleSubmit">
				Télécharger ma facture
			</b-button>
		</form>
	</b-modal>
</template>

<script>
	import { mapState } from "vuex";

	export default {
		props: {
			status: {
				type: Boolean,
				required: true,
				default: false
			}
		},
		data() {
			return {
				title: null,
				modalRefName: "ModalRegister",
				email: "",
				cgu: true,
				password: "",
				firstname: "",
				lastname: "",
				appName: "",
				accountAlreadyExist: false,
				appUrl: "",
				loading: false,
				registered: false
			};
		},
		computed: {
			...mapState(["app", "page", "guest"])
		},
		watch: {
			status() {
				if (this.status) {
					this.$refs[this.modalRefName].show();
				} else {
					this.$refs[this.modalRefName].hide();
				}
			}
		},
		created() {
			this.title = `Enregistrement de votre ${this.page.type === "invoices" ? "facture" : "devis"}`;
		},
		mounted() {
			this.$refs[this.modalRefName].$on("shown", () => {
				// Remove onbeforeunload
				window.onbeforeunload = null;
			});

			this.$refs[this.modalRefName].$on("hidden", () => {
				if (this.savingDocument === false && process.env.NODE_ENV === "production") {
					// Setup onbeforeunload
					window.onbeforeunload = function() {
						return "Êtes-vous sûrs de vouloir fermer la page?";
					};
				}

				this.$emit("update:status", false);
			});
		},
		methods: {
			async handleSubmit() {
				try {
					const { firstname, lastname, email, password, cgu, appName } = this.$data;

					this.title = "Téléchargement en cours...";
					this.loading = true;

					await this.$store.dispatch("register", {
						firstname,
						lastname,
						email,
						password,
						cgu
					});

					const { access_token } = await this.$store.dispatch("login", {
						email,
						password
					});

					const { domain } = await this.$store.dispatch("branding", { hostname_alias: null });

					const { id: appId, url } = await this.$store.dispatch("createApp", {
						token: access_token,
						appName,
						domain: domain ?? "sinao.app"
					});

					this.appUrl = url;
					this.$store.commit("id", appId);
					this.$store.commit("token", access_token);

					const { id: invoiceId } = await this.$store.dispatch("saveDocument", access_token);

					this.$store.commit("documentId", invoiceId);

					await this.$store.dispatch("updateOrganization", { token: access_token, appId });

					await this.$store.dispatch("updateUTM", {
						token: access_token,
						appId,
						utm: this.app.utm
					});

					this.download();

					setTimeout(() => {
						this.title = "Bienvenue sur Sinao !";
						this.registered = true;
						this.loading = false;
					}, 1000);
				} catch (error) {
					console.error(error);
					this.loading = false;
				}
			},
			download() {
				const { apiUrl, token, documentId, id } = this.app;

				let element = document.createElement("a");

				element.href = `${apiUrl}/apps/${id}/invoices/${documentId}/pdf?token=${token}&ts=${Math.floor(
					Math.random() * 100
				)}`;
				element.download = `${documentId}.pdf`;

				element.style.display = "none";
				document.body.appendChild(element);

				element.click();

				document.body.removeChild(element);
			},
			goToApp() {
				const { token } = this.app;

				const url = `${this.appUrl}accounting/billing/main/?login=${token}`;

				setTimeout(() => {
					if (window.parent) {
						window.parent.location.href = url;
					} else {
						window.location.href = url;
					}
				}, 1000);

				// Hide the modal manually
				this.$emit("update:status", false);
			}
		}
	};
</script>

<style>
	.b-overlay.position-absolute {
		margin: 0 0 0 -32px;
	}
</style>
